import { Table } from 'antd'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { reeleAfsluitingen } from './queries'
import { copyToClipboard, evaluateMoment, formatDuration, HideClosed, sorter } from './helpers'

const dutchNames = {
  'nummer': 'nummer VKM',
  'start': 'start',
  'eind': 'eind',
  'aanleiding': 'aanleiding'
}

const columns = ['nummer', 'start', 'eind', 'aanleiding']
  .map((key) => ({
    title: _.startCase(dutchNames[key]),
    dataIndex: key,
    key,
    sorter: (a, b) => sorter(a[key], b[key])
  }))
columns[0].render = (item) => {
  return <>
    {
      <a key={item.key} href={`https://coentunnel.relaticsonline.com/2ddcb363-983d-ee11-b697-001dd8d702c0/ShowObject.aspx?Key=${item.relatics}`} target="_blank">{item.nummer}</a>
    }
  </>;
}

const reduceReeleAfsluitingenData = (nodeSets) => {
  if (!!nodeSets.nummer) {
    return nodeSets.nummer.map((nummer, i) => ({
      key: i,
      nummer: {key: i, nummer: nodeSets.nummer[i]?.value || '', relatics: nodeSets.relatics[i]?.value || ''},
      start: evaluateMoment(nodeSets.start[i]),
      eind: evaluateMoment(nodeSets.eind[i]),
      aanleiding: nodeSets.aanleiding[i]?.value || ''
    }))
  } else {
    return []
  }
}

const ReeleAfsluitingen = ({ ...props }) => {

  const [hideClosed, setHideClosed] = useState(true)
  const { spaceId } = useParams();
  const { data, isLoading, error } = useQuery(
    [`${spaceId}.reeleAfsluitingen.dashboard`],
    async () => {
      const res = await new Weaver.Sparql(reeleAfsluitingen(), undefined, 'afsluitingen').find()
      return reduceReeleAfsluitingenData(res || {})
    }
  )
  const quarterEndDate = useQuery({
      queryKey: [`${spaceId}.reeleAfsluitingen.quarterEndDate`],
      queryFn: async () => {
        const node = await Weaver.Node.load(props.quarter);
        return node.get('http://pms.coentunnelcompany.nl/rdl#endDate').format("DD-MM-YYYY HH:mm");
      },
      enabled: (props.quarter !== undefined)
    }
  )

  const title = (_data) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        { copyToClipboard(reduceReeleAfsluitingenData(_data))() }
        <HideClosed setHideClosed={setHideClosed}/>
      </div>
    )
  }

  const filterHidden = (_data) => {
    return _data.filter((item) => item.eind === quarterEndDate.data)
  }

  return (
    <Table
      title={data ? () => title(data) : () => null}
      pagination={{position: ["topRight", "none"]}}
      loading={isLoading && quarterEndDate.isLoading}
      bordered={true}
      columns={columns}
      dataSource={hideClosed ? filterHidden(data || []) : data}
      {...props}
    />
  )
}

ReeleAfsluitingen.title = "Reële afsluitingen"

export default ReeleAfsluitingen
